import FormattedText, {
  getPlainText,
} from "../../../FormattedText/FormattedText";
import LandingButton from "../../../LandingButton/LandingButton";
import { TextNodeType } from "../../CommonLandingMweb.types";
import { COMMON_LANDING_CONSTANTS } from "../../constants";
import {
  Container,
  Content,
  CountryButton,
  CountryText,
  EditLink,
  ShadowWrap,
  TravelText,
} from "./Styles";

interface StickyHeaderProps {
  heading?: { title?: TextNodeType };
  selectedCountry?: string;
  showCountrySelector?: boolean;
  ctaLabel?: TextNodeType;
  editLabel?: TextNodeType;
  fromDate?: Date;
  toDate?: Date;
  travellerCount?: number;
  selectedPlanType?: string;
  onCountryEditPress?: () => void;
  onExplorePlansPress?: () => void;
}

const formatDate = (value?: Date) => {
  if (!value) return "";
  return value.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
};

const scrollToTop = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const StickyHeader = ({
  heading: _heading,
  selectedCountry,
  showCountrySelector = true,
  ctaLabel,
  editLabel,
  fromDate,
  toDate,
  travellerCount,
  selectedPlanType,
  onCountryEditPress,
  onExplorePlansPress,
}: StickyHeaderProps) => {
  const travelInfo = [
    fromDate && toDate ? `${formatDate(fromDate)} - ${formatDate(toDate)}` : "",
    travellerCount
      ? `${travellerCount} ${
          travellerCount === 1
            ? COMMON_LANDING_CONSTANTS.TRAVELLER
            : COMMON_LANDING_CONSTANTS.TRAVELLERS
        }`
      : "",
    selectedPlanType ? `${selectedPlanType} plan` : "",
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Container>
      <ShadowWrap>
        <Content>
          {showCountrySelector ? (
            <CountryButton onClick={scrollToTop}>
              <div>
                <CountryText>{selectedCountry}</CountryText>
                <TravelText>{travelInfo}</TravelText>
              </div>
              <EditLink>
                <FormattedText value={editLabel || "Edit"} />
              </EditLink>
            </CountryButton>
          ) : null}
          <LandingButton
            customTitle={getPlainText(ctaLabel) || "Explore Plans"}
            customWidth="100%"
            customHeight="44px"
            margin="12px 0 0"
            shadowVariant="none"
            onClick={onExplorePlansPress}
          />
        </Content>
      </ShadowWrap>
    </Container>
  );
};
